import React from 'react';
import { isBefore, parseISO } from 'date-fns';
import {
  dateUI,
  dateSchema,
  dateRangeUI,
  dateRangeSchema,
  currentOrPastDateUI,
  currentOrPastDateSchema,
  titleUI,
  dateOfBirthSchema,
  dateOfBirthUI,
  currentOrPastDateRangeUI,
  currentOrPastDateRangeSchema,
  currentOrPastDateDigitsUI,
  currentOrPastDateDigitsSchema,
  currentOrPastMonthYearDateUI,
  currentOrPastMonthYearDateRangeUI,
  currentOrPastMonthYearDateSchema,
  currentOrPastMonthYearDateRangeSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

const onOrAfterDateCurrentOrPast = (errors, dateString, formData) => {
  if (
    dateString &&
    formData.dateCurrentOrPast &&
    isBefore(parseISO(dateString), parseISO(formData.dateCurrentOrPast))
  ) {
    errors.addError('Enter a date on or after the currentOrPast date');
  }
};

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Date web components'),
    'view:dateUISubTitle': {
      'ui:description': <h4>dateUI and dateRangeUI</h4>,
    },
    dateCurrentOrPast: dateUI({
      title: 'dateUI - allowedDates: currentOrPast',
      allowedDates: 'currentOrPast',
    }),
    dateCurrentOrFuture: dateUI({
      title: 'dateUI - allowedDates: currentOrFuture',
      allowedDates: 'currentOrFuture',
    }),
    dateAny: dateUI({
      title: 'dateUI - allowedDates: any',
      allowedDates: 'any',
    }),
    dateOnOrAfter: dateUI({
      title: 'dateUI - any, on or after the currentOrPast date',
      allowedDates: 'any',
      validations: [onOrAfterDateCurrentOrPast],
    }),
    dateRangeMixed: dateRangeUI(
      {
        title: 'dateRangeUI - currentOrPast from (service start)',
        allowedDates: 'currentOrPast',
      },
      {
        title: 'dateRangeUI - currentOrFuture to (expected end)',
        hint: 'Your best estimate is fine',
        allowedDates: 'currentOrFuture',
      },
    ),
    dateWcv3: currentOrPastDateUI('Web component - Generic'),
    dateDigitsWcv3: currentOrPastDateDigitsUI(
      'Web component - Date with digit month input',
    ),
    dateOfBirthWcv3: dateOfBirthUI('Web component - Date of birth'),
    'view:dateSubTitle': {
      'ui:description': <h4>Date range pattern</h4>,
    },
    dateRange: currentOrPastDateRangeUI(
      'Start date',
      'End date',
      'End date must be after start date',
    ),
    'view:monthYearDates': {
      'ui:description': <h4>Month year only</h4>,
    },
    dateMonthYear: currentOrPastMonthYearDateUI('Month and year only'),
    dateMonthYearOptional: currentOrPastMonthYearDateUI({
      title: 'Month and year only, month optional',
      monthOptional: true,
    }),
    dateMonthYearRange: currentOrPastMonthYearDateRangeUI(
      {
        title: 'Start date',
        hint: 'Start date must be before end date',
      },
      {
        title: 'End date',
        hint: 'End date must be after start date',
      },
    ),
  },
  schema: {
    type: 'object',
    properties: {
      'view:dateUISubTitle': {
        type: 'object',
        properties: {},
      },
      dateCurrentOrPast: dateSchema,
      dateCurrentOrFuture: dateSchema,
      dateAny: dateSchema,
      dateOnOrAfter: dateSchema,
      dateRangeMixed: dateRangeSchema,
      dateWcv3: currentOrPastDateSchema,
      dateDigitsWcv3: currentOrPastDateDigitsSchema,
      dateOfBirthWcv3: dateOfBirthSchema,
      'view:dateSubTitle': {
        type: 'object',
        properties: {},
      },
      dateRange: currentOrPastDateRangeSchema,
      'view:monthYearDates': {
        type: 'object',
        properties: {},
      },
      dateMonthYear: currentOrPastMonthYearDateSchema,
      dateMonthYearOptional: currentOrPastMonthYearDateSchema,
      dateMonthYearRange: currentOrPastMonthYearDateRangeSchema,
    },
    required: [
      'dateCurrentOrPast',
      'dateCurrentOrFuture',
      'dateWcv3',
      'dateDigitsWcv3',
      'dateMonthYear',
    ],
  },
};
